import React, { useEffect, useState } from 'react'
import Container from '@material-ui/core/Container'
import { makeStyles } from '@material-ui/core/styles'
import Presupuesto from './Presupuesto'
import Desagregado from './Desagregado'

const useStyles = makeStyles((theme) => ({
	title: {
		fontWeight: 600,
		textAlign: 'center',
		fontSize: 30,
		margin: '3em auto 1em',
		color: '#383838'
	},
	resume: {
		margin: '0 auto',
		textAlign: 'center',
		fontSize: 14,
		color: '#383838',
		maxWidth: 800
	}
}))

function Page() {
	const classes = useStyles()
	const [ desagregado, setDesagregado ] = useState(null)

	const [ departmentsData, setDepartmentsData ] = useState('')
	const [ departmentsDetail, setDepartmentsDetail ] = useState('')
	const [ provincesData, setProvincesData ] = useState('')

	async function fetchUrl() {
		const response = await fetch(process.env.REACT_APP_API_URL + 'presupuesto')
		const json = await response.json()
		const { presupuesto, linea, detalle_regiones, presupuesto_provincias } = json

		// Obtener data para el mapa
		let departments = []
		
		detalle_regiones.map((item) => {
			const values = Number(item[2])
			const porc = Number(item[4]).toFixed(0)
			departments = [
				...departments,
				{ id: item[0], value: porc, total: values }
			]
			return item
		})
		setDepartmentsData(departments)

		// Obtener por presupuesto_provincias
		let provinces = []
		presupuesto_provincias.map((item) => {
			const porc = Number(item[8]).toFixed(0)
			const presupuesto = Number(item[5]).toLocaleString(undefined, { minimumFractionDigits: 2 })
			provinces = [
				...provinces,
				{ id: item[0], value: porc, name: item[3], prov: item[2], alcalde: item[4], presupuesto}
			]
			return item
		})
		setProvincesData(provinces)

		// detalle
		let departmentsDetail = []
		presupuesto.map((item) => {
			const porc = Number(item[8]).toFixed(0)
			const presupuesto = Number(item[5]).toLocaleString(undefined, { minimumFractionDigits: 2 })
			departmentsDetail = [
				...departmentsDetail,
				{ id: item[0], value: porc, name: item[3], province: item[2], alcalde: item[4], presupuesto}
			]
			return item
		})
		setDepartmentsDetail(departmentsDetail)

		/*const departments = [ ...new Set(presupuesto.map((elem) => elem[0])) ]
		let departmentsData = []
		departments.map((department) => {
			const municipios = presupuesto.filter((f) => f[0] === department)
			const cantMunicipios = municipios.length
			const values = municipios.filter((m) => Number(m[6]) === 0).length
			const porcentaje = values / cantMunicipios * 100
			departmentsData = [
				...departmentsData,
				{ id: department, candidates: municipios, value: porcentaje, cant: values, total: cantMunicipios }
			]
			return department
		})
		setDepartmentsData(departmentsData)*/

		// Desagregado

		const desagregadoFormat = linea.map((item) => {
			const name = item[0] ? `${item[0]}% a ${item[1]}%` : `${item[1]}%`
			const value = Number(item[2])
			return { name, value }
		})
		setDesagregado(desagregadoFormat)
	}

	//console.log(departmentsData)

	useEffect(() => {
		fetchUrl()
	}, [])

	return (
		<section id="mapa" style={{ minHeight: '100vh' }}>
			<Container maxWidth="lg" style={{ margin: '2em auto 4em', maxWidth: 1080 }}>
				<h1 className={classes.title}>Seguimiento al presupuesto Covid-19 de los municipios</h1>
				
				<Desagregado desagregado={desagregado} />
				<Presupuesto data={departmentsDetail} departmentsData={departmentsData} provincesData={provincesData} />
				<div>
					<p className={classes.resume}>
						<b>* Información referencial con los datos reportados al Ministerio de Economía y Finanzas.</b>
					</p>
					<p className={classes.resume}>(Última actualización: 8:00 p.m. del 5 de mayo, 2020)</p>
				</div>
			</Container>
		</section>
	)
}

export default Page
